import AnchorAdapter from "./Anchor";

export default AnchorAdapter;
